import CircleLoader from "@modules/loader/CircleLoader";
import { useLoaderStore } from "@modules/loader/useLoader.hook";

interface SkinProductImageProps {
  thumbnail: string | undefined;
}

export const SkinProductImage = ({ thumbnail }: SkinProductImageProps) => {
  const loaderStore = useLoaderStore();

  return (
    <div
      className={
        "background-image-[var(--image-url)] relative h-[500px] w-full max-w-[500px] rounded-2xl bg-top bg-no-repeat"
      }
      style={
        {
          "--image-url": `url(${
            !loaderStore.isLoadingBySkeleton() && thumbnail
          })`,
        } as React.CSSProperties
      }
    >
      <CircleLoader />
    </div>
  );
};
